import React, { useEffect, useState } from "react";
import RoomBanner from "../components/ourrooms/RoomBanner";
import Rooms from "../components/home/Rooms";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed } from "../hooks/useToast";
import { fetchRoomBanner, fetchRoomData } from "../api/RoomsApi";
import { IRoomBannerData } from "../exports/interfaces";
import { useRoomContext } from "../context/RoomContext";

const OurRooms = () => {
  const { setLoading } = useLoader();
  const { roomData, setRoomData } = useRoomContext();
  const [roomBanner, setRoomBanner] = useState<IRoomBannerData[]>([]);
  useEffect(() => {
    Promise.all([fetchRoomBanner()])
      .then(([roomBannerData]) => {
        setRoomBanner(roomBannerData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setLoading]);
  useEffect(() => {
    if (roomData.length === 0) {
      Promise.all([fetchRoomData()])
        .then(([RoomData]) => {
          setRoomData(RoomData);
        })
        .catch((error) => {
          dynamicFailed(error.response.data.error.message);
        });
    }
  }, [roomData.length, setRoomData]);
  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
        // onLoad={() => setTimeout(() => setLoading(false), 2000)}
      >
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            <div className="inner_wrapper">
              <div className="sidebar_content full_width">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="204"
                  className="elementor elementor-204 elementor-662"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <RoomBanner roomBanner={roomBanner} />
                      <Rooms />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br className="clear" />
        </div>
      </body>
    </>
  );
};

export default OurRooms;
